import { Client, Account } from 'appwrite';

export const IMPERSONATION_STORAGE_KEY = 'ppa.impersonatedUserId';

const client = new Client();

// Define a helper function to check and log if default values are being used
export function getEnvVariable(name: string, defaultValue: string) {
  const value = process.env[name];
  if (value === undefined) {
    console.warn(`Environment variable ${name} is not set. Using default value: ${defaultValue}`);
    return defaultValue;
  }
  return value;
}

export const APPWRITE_ENDPOINT = getEnvVariable('REACT_APP_ENDPOINT', 'endpoint');
export const APPWRITE_PROJECT_ID = getEnvVariable('REACT_APP_PROJECT_ID', 'project');

client
.setEndpoint(APPWRITE_ENDPOINT)
.setProject(APPWRITE_PROJECT_ID);
// .setKey(process.env.APPWRITE_FUNCTION_API_KEY)
// .setSelfSigned(true);
;

export const applyImpersonationTarget = (userId: string | null) => {
  const mutableClient = client as any;

  if (typeof mutableClient.setImpersonateUserId === 'function') {
    mutableClient.setImpersonateUserId(userId || '');
  }

  mutableClient.headers = mutableClient.headers || {};
  if (userId) {
    mutableClient.headers['X-Appwrite-Impersonate-User-Id'] = userId;
  } else {
    delete mutableClient.headers['X-Appwrite-Impersonate-User-Id'];
  }
};

export const getStoredImpersonationTarget = () => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(IMPERSONATION_STORAGE_KEY);
};

applyImpersonationTarget(getStoredImpersonationTarget());

const account = new Account(client);

// Function to create a user account
export const createUser = async (email: string, password: string) => {
    try {
      const response = await account.create('unique()', email, password);
      console.log(response);
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  
  // Function to create an email session (login)
  export const createEmailSession = async (email: string, password: string) => {
    try {
      const response = await account.createSession(email, password);
      console.log(response);
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  
  export default client;